var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 11.5C6.05 11.5 5.875 11.425 5.725 11.275C5.575 11.125 5.5 10.95 5.5 10.75V3.75C5.5 3.55 5.575 3.375 5.725 3.225C5.875 3.075 6.05 3 6.25 3H11.75C11.95 3 12.125 3.075 12.275 3.225C12.425 3.375 12.5 3.55 12.5 3.75V10.75C12.5 10.95 12.425 11.125 12.275 11.275C12.125 11.425 11.95 11.5 11.75 11.5H6.25ZM6.25 10.75H11.75V3.75H6.25V10.75ZM4.75 13C4.55 13 4.375 12.925 4.225 12.775C4.075 12.625 4 12.45 4 12.25V4.7125H4.75V12.25H10.675V13H4.75ZM6.25 3.75V10.75V3.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.0e43ef8f09e7eec7e9f4262dc10538d5.svg";
export { ForwardRef as ReactComponent };